var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"e3-svg",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":Number(_vm.size),"height":Number(_vm.size),"viewBox":"0 0 24 24"}},[_c('circle',{attrs:{"fill":"currentColor","cx":"12","cy":"12","r":"6"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }